import React, { Component } from "react";
import ImgList from "./imgList";
import DoubleDownArrow from "./doubleDownArrow";
import PropTypes from "prop-types";
import axios from "axios";

class Cards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      dataload: [],
      dataExtra: [],
      page: 0,
      pageSize: 12,
      loadMoreVisible: false,
      initial: true,
      noResultsMessage: false,
      instructions: false
    };

    this.loadMore = this.loadMore.bind(this);
    this.renderPosts = this.renderPosts.bind(this);
  }

  componentDidMount() {
    this.renderPosts();
  }

  componentDidUpdate(prevState) {
    if (this.props.params != prevState.params) {
      this.setState(
        {
          page: 0,
          initial: true
        },
        this.renderPosts
      );
    }
  }

  loadMore() {
    this.setState(
      {
        data: this.state.data.concat(this.state.dataload),
        page: this.state.page + 1
      },
      this.renderPosts
    );
  }

  renderPosts() {
    let paramsObj = {
      pageSize: this.state.pageSize,
      page: this.state.page
    };

    if (this.props.params) {
      if (!this.props.params.keyword && !this.props.params.tag) {
        this.setState({
          instructions: true,
          noResultsMessage: false,
          data: []
        });
        return;
      } else {
        paramsObj = { ...paramsObj, ...this.props.params };
        this.setState({ instructions: false });
      }
    }

    this.setState({
      loadMoreVisible: false
    });

    axios
      .get(this.props.api, { params: paramsObj })
      .then(results => {
        if (results.data.Corrected) {
          this.props.correctSpelling(results.data.SearchedKeyword);
        }

        var articles = results.data.Results || [];
        if (articles.length > 0 || this.state.dataExtra.length > 0) {
          this.setState({
            noResultsMessage: false
          });

          var allArticles = [...this.state.dataExtra, ...articles];

          if (this.state.initial) {
            if (this.props.loadMore) {
              this.setState(
                {
                  page: this.state.page + 1,
                  initial: false,
                  data: allArticles.slice(0, this.state.pageSize),
                  dataExtra: allArticles.slice(this.state.pageSize)
                },
                this.renderPosts
              );
            } else {
              this.setState({
                data: allArticles.slice(0, this.state.pageSize),
                dataExtra: allArticles.slice(this.state.pageSize)
              });
            }
          } else {
            this.setState({
              dataload: allArticles.slice(0, this.state.pageSize),
              dataExtra: allArticles.slice(this.state.pageSize),
              loadMoreVisible: true
            });
          }
        } else {
          if (this.state.initial) {
            this.setState({
              loadMoreVisible: false,
              noResultsMessage: true,
              instructions: false,
              data: [],
              dataExtra: []
            });
          } else {
            this.setState({
              loadMoreVisible: false
            });
          }
        }
      })
      .catch(err => {
        throw err;
      });
  }

  render() {
    return (
      <section>
        {this.state.noResultsMessage && (
          <div className="noresultsmessage container">
            We&apos;re sorry, no results were found that matched your search. Please
            check your spelling or try a new search.
          </div>
        )}
        {this.state.instructions && (
          <div className="noresultsmessage red container">
            Please type a search term or use the Tag filter.
          </div>
        )}

        {this.state.data.length > 0 && (
          <div className="cards-container">
            <ImgList data={this.state.data} />
            <div
              onClick={this.loadMore}
              className={
                "loadMoreCtn " + (this.state.loadMoreVisible ? "show" : "hide")
              }
            >
              {
                <button type="button" className="loadMoreBtn">
                  Load More Posts
                  <DoubleDownArrow />
                </button>
              }
            </div>
          </div>
        )}
      </section>
    );
  }
}

Cards.propTypes = {
  api: PropTypes.string,
  loadMore: PropTypes.bool,
  params: PropTypes.object,
  correctSpelling: PropTypes.func
};

export default Cards;
